import logo from './logo.svg';
import './App.css';

import { Route, Routes } from 'react-router-dom';

import About from './components/element/About/About';
import OurContact from './components/element/OurContact/OurContact';
import Home from './components/element/Home/Home';
import Navbar from './components/pages/Navbar/Navbar';
import OurService from './components/element/OurServices/OurService';
import Local from './components/element/Hospital/Local';
import International from './components/element/Hospital/International';
import Treatment from './components/element/Treatment/Treatment';
import Procedure from './components/element/Treatment/Procedure';
import OrganTransplant from './components/element/Treatment/OrganTransplant';
import Tourism from './components/element/Tourism/Tourism';
import Oncology from './components/element/Treatment/TreatmentSection/Oncology';
import Hematology from './components/element/Treatment/TreatmentSection/Hematology';
import Trransplant from './components/element/Treatment/TreatmentSection/Trransplant';
import Nephrology from './components/element/Treatment/TreatmentSection/Nephrology';
import Spine from './components/element/Treatment/TreatmentSection/Spine';
import Cosmetic from './components/element/Treatment/TreatmentSection/Cosmetic';
import Pediatric from './components/element/Treatment/TreatmentSection/Pediatric';
import Bariatric from './components/element/Treatment/TreatmentSection/Bariatric';
import Gastro from './components/element/Treatment/TreatmentSection/Gastro';
import Gyno from './components/element/Treatment/TreatmentSection/Gyno';
import Cardio from './components/element/Treatment/TreatmentSection/Cardio';
import Orthopaedic from './components/element/Treatment/TreatmentSection/Orthopaedic';
import Ent from './components/element/Treatment/TreatmentSection/Ent';

function App() {
  return (
    <>
    <Navbar/>
    <Routes>
      <Route path='/' element={<Home/>} />
      <Route path='/about' element={<About/>} />
      <Route path='/contact' element={<OurContact/>}/>
      <Route path='/ourservice' element={<OurService/>}/>
      <Route path='/hospitals/local' element={<Local/>} />
      <Route path='/hospitals/international' element={<International/>} />
      <Route path='/treatments/procedure' element={<Procedure/>}/>
      <Route path='/treatments/organ' element={<OrganTransplant/>} />
      <Route path='/ourtreatment' element={<Treatment/>} />
      <Route path='/medicaltourism' element={<Tourism/>}/>
      <Route path='/treatments/oncology' element={<Oncology/>}/>
      <Route path='/treatments/hematology' element={<Hematology/>}/>
      <Route path='/treatments/transplant' element={<Trransplant/>}/>
      <Route path='/treatments/nephrology' element={<Nephrology/>}/>
      <Route path='/treatments/spine' element={<Spine/>}/>
      <Route path='/treatments/cosmetic' element={<Cosmetic/>}/>
      <Route path='/treatments/pediatric' element={<Pediatric/>}/>
      <Route path='/treatments/bariatric' element={<Bariatric/>}/>
      <Route path='/treatments/gastro' element={<Gastro/>}/>
      <Route path='/treatments/gynae' element={<Gyno/>}/>
      <Route path='/treatments/cardio' element={<Cardio/>}/>
      <Route path='/treatments/orthopaedic' element={<Orthopaedic/>}/>
      <Route path='/treatments/ent' element={<Ent/>}/>

    </Routes>

    </>
  );
}

export default App;
